import { FiSearch } from "react-icons/fi";
import { BsFilter, BsLayoutThreeColumns } from "react-icons/bs";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { MdOutlineDelete, MdOutlineKeyboardArrowDown } from "react-icons/md";
import { IoIosCloseCircleOutline, IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { modalActions } from "../store/modalSlice";
import { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
export default function DashboardFilters({ filters }) {

    const selectedListings = useSelector(state => state.selectedListings)
    const dispatch = useDispatch()

    const [isStatusDropdownActive, setIsStatusDropdownActive] = useState(false)
    const [isPauseDropdownActive, setIsPauseDropdownActive] = useState(false)
    const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false)

    const statusDropdownRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setIsStatusDropdownActive(false)
                setIsPauseDropdownActive(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleDeleteAllListings = () => {
        dispatch(modalActions.openModal({ details: { category: 'listings', name: `${selectedListings.listings.length} listime` } }))
    }

    const handleStatusDropdown = (e) => {
        e.stopPropagation();
        setIsStatusDropdownActive(!isStatusDropdownActive)
        setIsPauseDropdownActive(false)
    }

    const handleStatusSelect = (status) => {
        const syntheticEvent = { target: { id: status, innerText: status } }
        filters.handleFilterSelect(syntheticEvent)
        setIsStatusDropdownActive(false)
        setIsPauseDropdownActive(false)
    }

    const handlePauseDropdown = (e) => {
        e.stopPropagation();
        setIsPauseDropdownActive(!isPauseDropdownActive)
    }

    const handlePauseSelect = (type) => {
        if (type === 'on') {
            filters.handlePauseOnFilter()
        } else {
            filters.handlePauseOffFilter()
        }
        setIsStatusDropdownActive(false)
        setIsPauseDropdownActive(false)
    }

    const getStatusLabel = () => {
        if (!filters.selectedFilter) return 'Të gjitha'
        if (filters.selectedFilter === 'Approved' && filters.pauseOnFilter) {
            return `Approved (Pause ${filters.pauseOnFilter})`
        }
        return filters.selectedFilter
    }

    // selectedFilter is an array on the listings dashboard but a string on the others —
    // these helpers report selection state correctly for both shapes.
    const isStatusActive = (option) =>
        Array.isArray(filters.selectedFilter)
            ? filters.selectedFilter.includes(option)
            : filters.selectedFilter === option
    const noStatusActive = Array.isArray(filters.selectedFilter)
        ? filters.selectedFilter.length === 0
        : !filters.selectedFilter

    // Count active filters for badge
    const activeFiltersCount = [
        filters.selectedFilter,
        filters.searchNameInput,
        filters.searchTextInput,
        filters.searchIdInput,
        filters.params?.start_date,
    ].filter(Boolean).length

    return (
        <div className="py-3 px-4">
            <div className="flex flex-col gap-3">
                {/* Mobile: Only Filter Toggle Button */}
                <div className="sm:hidden flex items-center justify-between">
                    <button
                        onClick={() => setIsMobileFiltersOpen(!isMobileFiltersOpen)}
                        className={`h-10 flex gap-2 items-center w-full justify-center px-4 rounded-xl border text-sm font-medium transition-all ${
                            isMobileFiltersOpen || activeFiltersCount > 0
                                ? 'border-primary bg-primary text-[#344054]'
                                : 'border-gray-200 dark:border-gray-600 text-[#344054] dark:text-gray-300'
                        }`}
                    >
                        <BsFilter style={{ fontSize: '18px' }} />
                        Filters
                        {activeFiltersCount > 0 && (
                            <span className="w-5 h-5 rounded-full bg-red-600 text-white flex items-center justify-center text-[11px]">
                                {activeFiltersCount}
                            </span>
                        )}
                    </button>
                    {selectedListings.listings.length > 0 && (
                        <div className="flex items-center gap-2">
                            {filters.onAssignTop && (
                                <button
                                    onClick={filters.onAssignTop}
                                    disabled={filters.isAssigningTop}
                                    title="Assign TOP to selected"
                                    className="h-8 px-3 rounded-xl border border-primary bg-primary text-[#344054] text-[12px] font-semibold hover:opacity-90 transition-opacity flex-shrink-0 disabled:opacity-50"
                                >
                                    {filters.isAssigningTop ? 'Adding...' : 'Make TOP'}
                                </button>
                            )}
                            <div
                                className="rounded-full p-1.5 text-red-600 border border-red-600 flex items-center justify-center hover:text-white hover:bg-red-600 cursor-pointer"
                                title="Delete All"
                                onClick={handleDeleteAllListings}
                            >
                                <MdOutlineDelete size={20} />
                            </div>
                        </div>
                    )}
                </div>

                {/* Mobile Filters Panel - collapsible */}
                {isMobileFiltersOpen && (
                    <div className="sm:hidden bg-gray-50 dark:bg-gray-800 rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                        <div className="flex justify-between items-center mb-4">
                            <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">Filters & Search</span>
                            <button
                                onClick={() => setIsMobileFiltersOpen(false)}
                                className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                            >
                                <IoMdClose size={20} />
                            </button>
                        </div>

                        <div className="flex flex-col gap-4">
                            {/* Unified Search */}
                            <div>
                                <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 block">Search by title, ID, or user</label>
                                <div className="relative w-full">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="w-full bg-white dark:bg-gray-700 p-2.5 pl-9 pr-8 border border-gray-200 dark:border-gray-600 rounded-xl outline-none text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400"
                                        value={filters.smartSearchInput || ''}
                                        onChange={filters.handleSmartSearchChange}
                                    />
                                    <FiSearch className="absolute top-1/2 -translate-y-1/2 left-3 text-gray-400 text-[16px]" />
                                    {filters.smartSearchInput && (
                                        <IoIosCloseCircleOutline
                                            className="absolute top-1/2 -translate-y-1/2 right-2 text-gray-400 text-[18px] cursor-pointer"
                                            onClick={() => filters.handleSmartSearchChange({ target: { value: '' } })}
                                        />
                                    )}
                                </div>
                            </div>

                            {/* ID Search */}
                            {filters.searchIdInput !== undefined && (
                                <div>
                                    <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 block">Search by ID</label>
                                    <div className="relative w-full">
                                        <input
                                            type="text"
                                            placeholder="Listing ID..."
                                            className="w-full bg-white dark:bg-gray-700 p-2.5 pl-9 pr-8 border border-gray-200 dark:border-gray-600 rounded-xl outline-none text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400"
                                            value={filters.searchIdInput}
                                            onChange={filters.handleSearchIdInputChange}
                                        />
                                        <FiSearch className="absolute top-1/2 -translate-y-1/2 left-3 text-gray-400 text-[16px]" />
                                        {filters.searchIdInput && (
                                            <IoIosCloseCircleOutline
                                                className="absolute top-1/2 -translate-y-1/2 right-2 text-gray-400 text-[18px] cursor-pointer"
                                                onClick={() => filters.handleSearchIdInputChange({ target: { value: '' } })}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* User Search */}
                            {filters.searchNameInput !== undefined && (
                                <div>
                                    <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 block">Search by user</label>
                                    <div className="relative w-full">
                                        <input
                                            type="text"
                                            placeholder="User name..."
                                            className="w-full bg-white dark:bg-gray-700 p-2.5 pl-9 pr-8 border border-gray-200 dark:border-gray-600 rounded-xl outline-none text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400"
                                            value={filters.searchNameInput}
                                            onChange={filters.handleSearchNameInputChange}
                                        />
                                        <FiSearch className="absolute top-1/2 -translate-y-1/2 left-3 text-gray-400 text-[16px]" />
                                        {filters.searchNameInput && (
                                            <IoIosCloseCircleOutline
                                                className="absolute top-1/2 -translate-y-1/2 right-2 text-gray-400 text-[18px] cursor-pointer"
                                                onClick={() => filters.handleSearchNameInputChange({ target: { value: '' } })}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Date Range */}
                            {filters.setDateRange && (
                                <div>
                                    <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1 block">Date range</label>
                                    <div className="flex items-center gap-2">
                                        <div
                                            className="flex-1 flex justify-between items-center gap-2 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl p-2.5 px-3 cursor-pointer text-gray-900 dark:text-gray-100"
                                            onClick={() => filters.handleIsDateRangeOpen(filters.isDateRangeOpen)}
                                        >
                                            <div className="text-sm">{filters.dateBtnLabel}</div>
                                            <MdOutlineKeyboardArrowDown fontSize={18} className="text-gray-500" />
                                        </div>
                                        {'start_date' in filters.params && (
                                            <button
                                                onClick={filters.removeDateFilter}
                                                className="p-2 text-gray-500 hover:text-red-600"
                                                title="Clear date filter"
                                            >
                                                <IoIosCloseCircleOutline fontSize={22} />
                                            </button>
                                        )}
                                    </div>
                                    {filters.isDateRangeOpen && (
                                        <div className="mt-2 overflow-auto">
                                            <DateRangePicker
                                                ranges={filters.dateRange}
                                                onChange={filters.handleDateRangeChange}
                                                moveRangeOnFirstSelection={false}
                                                showSelectionPreview={false}
                                                staticRanges={[]}
                                                inputRanges={[]}
                                                className="border border-gray-200 dark:border-gray-700 rounded-lg"
                                                rangeColors={['#C2CE2E']}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}


                            {/* Status Filter */}
                            {filters.categories && (
                                <div>
                                    <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 block">Status</label>
                                    <div className="flex flex-wrap gap-2">
                                        <button
                                            onClick={() => handleStatusSelect('Te gjitha')}
                                            className={`px-3 py-2 rounded-lg text-xs font-medium transition-all ${
                                                noStatusActive
                                                    ? 'bg-primary text-[#344054]'
                                                    : 'bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300'
                                            }`}
                                        >
                                            Të gjitha
                                        </button>
                                        {filters.categories.map((option) => (
                                            <button
                                                key={option}
                                                onClick={() => handleStatusSelect(option)}
                                                className={`px-3 py-2 rounded-lg text-xs font-medium transition-all flex items-center gap-1 ${
                                                    isStatusActive(option)
                                                        ? 'bg-primary text-[#344054]'
                                                        : 'bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300'
                                                }`}
                                            >
                                                {option === 'In Progress' ? 'In Progress' : option}
                                                {option === 'Updated' && filters.updatedStatusCount > 0 && (
                                                    <span className="w-4 h-4 rounded-full bg-red-600 text-white flex items-center justify-center text-[10px]">
                                                        {filters.updatedStatusCount}
                                                    </span>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                )}

                {/* Desktop: All filters inline */}
                <div className="hidden sm:flex sm:flex-row sm:justify-between sm:items-center gap-3">
                    <div className="flex flex-wrap gap-2 items-center">
                        {/* Unified Search input (Title, ID, User) */}
                        <div className="relative min-w-[200px] max-w-[280px]">
                            <input
                                type="text"
                                placeholder="Search by title, ID, or user..."
                                className="w-full bg-white dark:bg-gray-900 p-2 pl-8 pr-8 border border-gray-200 dark:border-gray-700 rounded-xl outline-none text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 focus:border-primary"
                                value={filters.smartSearchInput || ''}
                                onChange={filters.handleSmartSearchChange}
                            />
                            <FiSearch className="absolute top-1/2 -translate-y-1/2 left-2 text-gray-400 text-[16px]" />
                            {filters.smartSearchInput && (
                                <IoIosCloseCircleOutline
                                    className="absolute top-1/2 -translate-y-1/2 right-2 text-gray-400 text-[18px] cursor-pointer hover:text-gray-600 dark:hover:text-gray-300"
                                    onClick={() => filters.handleSmartSearchChange({ target: { value: '' } })}
                                />
                            )}
                        </div>

                        {filters.categories && (
                            <div className="relative flex-shrink-0" ref={statusDropdownRef}>
                                <div
                                    className={`h-8 flex gap-2 justify-center items-center px-3 text-nowrap border rounded-xl leading-3 cursor-pointer text-[13px] font-semibold transition-all ${
                                        filters.selectedFilter?.length > 0
                                            ? 'border-primary bg-primary text-[#344054]'
                                            : 'border-gray-200 dark:border-gray-600 text-[#344054] dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                                    }`}
                                    onClick={handleStatusDropdown}
                                >
                                    <BsFilter style={{ fontSize: '16px' }} />
                                    {filters.selectedFilter?.length > 0 ? `${filters.selectedFilter.length} selected` : 'All Statuses'}
                                    {filters.updatedStatusCount > 0 && !filters.selectedFilter?.includes('Updated') && (
                                        <span className="w-4 h-4 rounded-full bg-red-600 text-white flex items-center justify-center text-[10px]">{filters.updatedStatusCount}</span>
                                    )}
                                    <FaChevronDown fontSize={12} />
                                </div>
                                {isStatusDropdownActive && (
                                    <div className="absolute top-full mt-1 left-0 bg-white dark:bg-gray-800 rounded-xl z-20 min-w-[180px] border border-gray-200 dark:border-gray-700 shadow-lg">
                                        {filters.selectedFilter?.length > 0 && (
                                            <div
                                                className="px-3 py-2 text-xs text-primary font-semibold cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-700 rounded-t-xl"
                                                onClick={() => { filters.clearStatusFilter?.(); setIsStatusDropdownActive(false); }}
                                            >
                                                Clear all ({filters.selectedFilter.length})
                                            </div>
                                        )}
                                        {filters.categories.map((option, index) => {
                                            const isSelected = filters.selectedFilter?.includes(option);
                                            return (
                                                <div
                                                    key={option}
                                                    className={`flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 ${isSelected ? 'text-primary font-semibold' : 'text-gray-700 dark:text-gray-300'} ${index === filters.categories.length - 1 ? 'rounded-b-xl' : ''}`}
                                                    onClick={() => filters.handleFilterSelect(option)}
                                                >
                                                    <div className={`w-4 h-4 flex-shrink-0 rounded border flex items-center justify-center ${isSelected ? 'bg-primary border-primary' : 'border-gray-300 dark:border-gray-500'}`}>
                                                        {isSelected && <svg className="w-2.5 h-2.5 text-[#344054]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>}
                                                    </div>
                                                    <span>{option}</span>
                                                    {option === 'Updated' && filters.updatedStatusCount > 0 && (
                                                        <span className="ml-auto w-4 h-4 rounded-full bg-red-600 text-white flex items-center justify-center text-[10px]">{filters.updatedStatusCount}</span>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Filters + Columns buttons — same row as Te gjitha */}
                        {filters.setShowAdvancedFilters && (
                            <button
                                onClick={() => filters.setShowAdvancedFilters(v => !v)}
                                className={`flex items-center gap-1.5 h-8 px-3 rounded-xl border text-[13px] font-medium transition-all flex-shrink-0 ${
                                    filters.showAdvancedFilters
                                        ? 'border-primary bg-primary text-[#344054]'
                                        : 'border-gray-200 dark:border-gray-600 text-[#344054] dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                                }`}
                            >
                                <BsFilter size={15} />
                                Filters
                            </button>
                        )}
                        {filters.setShowColumnPicker && (
                            <div className="relative flex-shrink-0" ref={filters.columnPickerRef}>
                                <button
                                    onClick={() => filters.setShowColumnPicker(v => !v)}
                                    className={`flex items-center gap-1.5 h-8 px-3 rounded-xl border text-[13px] font-medium transition-all ${
                                        filters.showColumnPicker
                                            ? 'border-primary bg-primary text-[#344054]'
                                            : 'border-gray-200 dark:border-gray-600 text-[#344054] dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                                    }`}
                                >
                                    <BsLayoutThreeColumns size={14} />
                                    Columns
                                </button>
                                {filters.showColumnPicker && (
                                    <div className="absolute top-full mt-1 left-0 bg-white dark:bg-gray-800 rounded-xl z-20 min-w-[200px] border border-gray-200 dark:border-gray-700 shadow-lg p-2">
                                        {filters.ALL_COLUMNS?.map(col => (
                                            <label key={col.key} className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer text-[13px] text-gray-700 dark:text-gray-300">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.visibleColumns?.includes(col.key)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            const order = filters.ALL_COLUMNS.map(c => c.key);
                                                            const updated = [...filters.visibleColumns, col.key].sort((a, b) => order.indexOf(a) - order.indexOf(b));
                                                            filters.setVisibleColumns(updated);
                                                        } else {
                                                            filters.setVisibleColumns(prev => prev.filter(k => k !== col.key));
                                                        }
                                                    }}
                                                    className="accent-primary"
                                                />
                                                {col.label}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Date Range - Desktop */}
                    {filters.setDateRange && (
                        <div className="flex items-center gap-2">
                            {'start_date' in filters.params && (
                                <div onClick={filters.removeDateFilter} className="text-gray-500 hover:text-red-600 cursor-pointer flex-shrink-0" title="Clear date filter">
                                    <IoIosCloseCircleOutline fontSize={24} />
                                </div>
                            )}
                            <div
                                className="flex justify-between items-center gap-2 border border-gray-300 dark:border-gray-600 rounded-xl p-2 px-3 cursor-pointer leading-3 text-gray-900 dark:text-gray-100"
                                onClick={() => filters.handleIsDateRangeOpen(filters.isDateRangeOpen)}
                            >
                                <div className="text-nowrap text-sm">{filters.dateBtnLabel}</div>
                                <MdOutlineKeyboardArrowDown fontSize={16} className="text-gray-500" />
                            </div>
                            {selectedListings.listings.length > 0 && (
                                <div className="flex items-center gap-2">
                                    {filters.onAssignTop && (
                                        <button
                                            onClick={filters.onAssignTop}
                                            disabled={filters.isAssigningTop}
                                            title="Assign TOP to selected"
                                            className="h-8 px-3 rounded-xl border border-primary bg-primary text-[#344054] text-[12px] font-semibold hover:opacity-90 transition-opacity flex-shrink-0 disabled:opacity-50"
                                        >
                                            {filters.isAssigningTop ? 'Adding...' : 'Make TOP'}
                                        </button>
                                    )}
                                    <div
                                        className="rounded-full p-1 text-red-600 border border-red-600 flex items-center justify-center hover:text-white hover:bg-red-600 cursor-pointer flex-shrink-0"
                                        title="Delete All"
                                        onClick={handleDeleteAllListings}
                                    >
                                        <MdOutlineDelete size={20} />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Date Range Picker - Desktop only (mobile has it inline) */}
                {filters.isDateRangeOpen && filters.setDateRange && (
                    <div className="hidden sm:block w-full relative">
                        <DateRangePicker
                            ranges={filters.dateRange}
                            onChange={filters.handleDateRangeChange}
                            moveRangeOnFirstSelection={false}
                            showSelectionPreview={false}
                            staticRanges={[]}
                            inputRanges={[]}
                            className="absolute top-0 right-0 z-10 border border-gray-200 dark:border-gray-700 max-w-[calc(100vw-2rem)] overflow-auto"
                            rangeColors={['#C2CE2E']}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
